module.exports = __webpack_public_path__ + "static/media/user_management_menu_icon.08e9e22f.svg";